<button #trigger class="btn btn-secondary btn-block dialog-trigger" (click)="launch()">
  <cx-icon [type]="iconTypes.FILTER"></cx-icon>
  {{ 'productList.filterBy.label' | cxTranslate }}
</button>

<gen-active-facets></gen-active-facets>

<gen-facet-list *ngIf="isOpen$ | async" [isDialog]="hasTrigger" (closeList)="close()" [class.active]="isActive$ | async"
  [class.dialog]="hasTrigger"></gen-facet-list>